import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useIntl, FormattedMessage } from "react-intl";

import type { SelectionSource } from "../../schemas";
import { useLocale } from "../../hooks/use-locale";

interface LocaleSelectProps {
	readonly mode: Exclude<SelectionSource, "system">;
}

export const LocaleSelect: React.FC<LocaleSelectProps> = ({ mode }) => {
	const intl = useIntl();
	const { currentLocale, locales, setLocale } = useLocale();

	return (
		<FormControl>
			<InputLabel id="locale-select__label__language">
				<FormattedMessage id="Language" defaultMessage="Language" />
			</InputLabel>
			<Select
				labelId="locale-select__label__language"
				label={intl.formatMessage({ id: "Language", defaultMessage: "Language" })}
				value={currentLocale.locale}
				onChange={(e) => setLocale(e.target.value, mode)}
				inputProps={{ "data-testid": "locale-select__select__language" }}
				sx={{ maxWidth: 300 }}
			>
				{locales.map((locale) => (
					<MenuItem key={locale.key} value={locale.key} data-testid={`locale-select__option__${locale.key}`}>
						{locale.label}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};
